import { render } from "./WarehousePurchaseReceive.vue?vue&type=template&id=068a4c07&scoped=true"
import script from "./WarehousePurchaseReceive.vue?vue&type=script&lang=js"
export * from "./WarehousePurchaseReceive.vue?vue&type=script&lang=js"

import "./WarehousePurchaseReceive.vue?vue&type=style&index=0&id=068a4c07&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068a4c07"]])

export default __exports__